import React, { useContext } from "react";
import { Paper } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { AppVarsContext } from "../../context/AppVarsContext";

const GlassPanel = ({ children, sx = {}, component = "section" }) => {
  const { appAppearance } = useContext(AppVarsContext);

  return (
    <Paper
      component={component}
      elevation={0}
      sx={{
        position: "relative",
        overflow: "hidden",
        borderRadius: { xs: 3, md: 4 },
        border: `1px solid ${appAppearance.colors.border}`,
        background: `linear-gradient(180deg, ${alpha("#ffffff", 0.84)} 0%, ${alpha("#ffffff", 0.68)} 100%)`,
        backdropFilter: "blur(18px)",
        boxShadow: appAppearance.shadows.panel,
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          background: `linear-gradient(135deg, ${appAppearance.colors.surfaceSoft} 0%, transparent 58%)`,
          pointerEvents: "none",
        },
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
};

export default GlassPanel;
